const trimTrailingSlash = (value) => value.replace(/\/+$/, "");

const getRuntimeApiBaseUrl = () => {
  const explicitBaseUrl = String(process.env.REACT_APP_API_BASE_URL || "").trim();
  if (explicitBaseUrl) return trimTrailingSlash(explicitBaseUrl);

  if (typeof window !== "undefined" && window.location?.hostname) {
    const protocol = window.location.protocol || "http:";
    const origin = window.location.origin || `${protocol}//${window.location.host}`;
    const hostname = window.location.hostname;
    const apiPort = String(process.env.REACT_APP_API_PORT || "3000").trim() || "3000";
    const isLocalDevHost = ["localhost", "127.0.0.1", "0.0.0.0"].includes(hostname);
    const isCreateReactAppDev = process.env.NODE_ENV === "development";

    if (isCreateReactAppDev && isLocalDevHost) {
      return `${protocol}//${hostname}:${apiPort}`;
    }

    return origin;
  }

  const apiPort = String(process.env.REACT_APP_API_PORT || "3000").trim() || "3000";
  return `http://localhost:${apiPort}`;
};

export const API_BASE_URL = getRuntimeApiBaseUrl();
export const FOOTBALL_IMAGE_BASE_URL = "https://cdn.footystats.org/img";
